export const BuildInfo = {timestamp:1771445916000}
